fragment EmailAutomationStatus on EmailAutomationStatus {
    id
    status
    isPaused
    canCancel
    canStart
    sender {
        id
    }
    lead {
        id
        name
        number
        status
        htmlUrl
        priority
        avatarUrl
        contacts {
            primaryEdge {
                node {
                    id
                    name
                    htmlUrl
                    emailAddresses {
                        primary {
                            value {
                                address
                            }
                        }
                    }
                }
            }
        }
    }
    emailAutomation {
        id
        emailList {
            id
            name
            ... on EmailSequenceTemplate {
                emailSequenceTemplateMessages {
                    id
                }
            }
        }
    }
    emailSequence {
        id
        emailSequenceTemplate {
            id
            creatorUser {
                id
            }
        }
        emailsQueued {
            id
            htmlUrl
            deliveryTime
            isAlreadySent
        }
        nextUnsentEmail {
            id
        }
    }
    firstName {
        required
        value
    }
    lastName {
        required
        value
    }
    emailAddress {
        required
        value
    }
    companyName {
        required
        value
    }
}
